module.exports = __webpack_public_path__ + "img/img_nav_lang_hover.cb4595ff.svg";